// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"etSCu":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "aifoH": "splide.d38d5f8e.js",
    "2NPNQ": "splide.1209191d.js"
});

},{}],"7bXFY":[function(require,module,exports,__globalThis) {
require("80dad0b8a250173c").then(function(param) {
    var Splide = param.Splide;
    document.querySelectorAll(".content-columns-with-cards .splide").forEach(function(el) {
        var label = el.dataset.sliderLabel;
        var describedById = el.dataset.sliderDescribedby;
        var applyAriaAttrs = function() {
            if (label) el.setAttribute('aria-label', label);
            if (describedById) el.setAttribute('aria-describedby', describedById);
        };
        var removeAriaAttrs = function() {
            el.removeAttribute('aria-label');
            el.removeAttribute('aria-describedby');
        };
        applyAriaAttrs();
        var splide = new Splide(el, {
            type: 'slide',
            arrows: true,
            pagination: true,
            perPage: 1,
            gap: '2rem',
            mediaQuery: 'min',
            breakpoints: {
                1024: {
                    destroy: true
                }
            },
            i18n: {
                slide: 'Column'
            }
        });
        splide.on('destroy', removeAriaAttrs);
        splide.on('mounted', applyAriaAttrs);
        splide.mount();
    });
}).catch(console.error); // Promise.all([import('gsap'), import('gsap/ScrollTrigger')])
 // 	.then(([{ gsap }, { ScrollTrigger }]) => {
 // 		gsap.registerPlugin(ScrollTrigger);
 // 		document.querySelectorAll('.content-columns-with-cards').forEach(wrapper => {
 // 		const bgImg = wrapper.querySelector('.img-anim');
 // 		const imgWrapper = wrapper.querySelector('.img-wrapper-anim');
 // 		const header = wrapper.querySelector('.header-anim');
 // 		const content = wrapper.querySelectorAll('.content-anim');
 // 		const container = wrapper.querySelector('.sorbet-align-container');
 // 		if(!bgImg || !imgWrapper || !content.length) return;
 // 		let getOffset;
 // 		if(header) {
 // 			getOffset = () => {
 // 				const gap = parseFloat(getComputedStyle(container).rowGap) || 0;
 // 				return header.offsetHeight + gap;
 // 			};
 // 		} else {
 // 			getOffset = () => 0;
 // 		}
 // 		content.forEach(el => gsap.set(el, { opacity: 0, y: 20 }));
 // 		gsap.set(bgImg, { scale: .25, y: '8%', borderRadius: '80% 80% 0 0' });
 // 		const tl = gsap.timeline({
 // 			scrollTrigger: {
 // 			trigger: imgWrapper,
 // 			start: '8% bottom',
 // 			end: 'bottom bottom',
 // 			scrub: .5,
 // 			invalidateOnRefresh: true,
 // 			},
 // 		});
 // 		tl.to(bgImg, { scale: 1, y: '0%', duration: 0.45 })
 // 			.to(bgImg, { borderRadius: '0', duration: 0.6 }, '<')
 // 			.to(imgWrapper, { y: () => -getOffset() }, 0);
 // 		if(header) { new ResizeObserver(() => ScrollTrigger.refresh()).observe(header); }
 // 		tl.to(content, {
 // 			opacity: 1,
 // 			y: 0,
 // 			stagger: 0.1,
 // 			duration: 0.2});
 // 		});
 // 	})
 // 	.catch(console.error);

},{"80dad0b8a250173c":"btIxh"}],"btIxh":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("cde66c3df8638403")(module.bundle.resolve("2NPNQ")),
    require("cde66c3df8638403")(module.bundle.resolve("aifoH"))
]).then(function() {
    return module.bundle.root('7s80R');
});

},{"cde66c3df8638403":"1MWbm"}],"1MWbm":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"4yBbG"}],"4yBbG":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}]},["etSCu","7bXFY"], "7bXFY", "parcelRequired6e5", {}, "../../../../", "/")

//# sourceMappingURL=content-columns-with-cards.js.map
